<div class="row">

    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 datepicker-custom ">
        <div class="form-inline">
            <div class="form-group">
                <input autocomplete="off" [startDate]="{year: 2019, month: 5, day: 1}" class="form-control " (click)="d.toggle()"
                    placeholder="gg-mm-aaaa" name="dp" [(ngModel)]="globalData.datePicker.dataSelezionata"
                    ngbDatepicker #d="ngbDatepicker">

                <a (click)="globalData.aggiornaStorico(globalData.datePicker.dataSelezionata)" skipLocationChange=true
                    class="btn btn-primary">Scegli
                    una data</a>
            </div>
        </div>
    </div>
</div>